import Reveal, { SectionHeading } from "../components/Reveal";
import { PROCESS_STEPS } from "../data";

function StepCard({ step, index }) {
  const left = index % 2 === 0;
  return (
    <div className="relative lg:grid lg:grid-cols-2 lg:gap-16">
      <Reveal
        delay={0.05}
        className={`${left ? "lg:col-start-1 lg:text-right" : "lg:col-start-2"} pl-16 lg:pl-0 pb-10`}
      >
        <p className="font-display text-5xl sm:text-6xl font-bold text-outline leading-none">
          {String(index + 1).padStart(2, "0")}
        </p>
        <h3 className="mt-3 font-display text-xl sm:text-2xl font-bold uppercase text-stone-900">
          {step.title}
        </h3>
        <p className="mt-2 text-sm sm:text-base leading-relaxed text-stone-600">{step.desc}</p>
        {step.chips && (
          <div className={`mt-4 flex flex-wrap gap-2 ${left ? "lg:justify-end" : ""}`}>
            {step.chips.map((c) => (
              <span
                key={c}
                className="rounded-full border border-amber-600/40 bg-amber-500/10 px-3 py-1 text-[11px] font-tech uppercase tracking-wider text-amber-800"
              >
                {c}
              </span>
            ))}
          </div>
        )}
      </Reveal>
      {/* node */}
      <span className="absolute left-[9px] lg:left-1/2 lg:-translate-x-1/2 top-2 h-4 w-4 rounded-full border-2 border-amber-500 bg-[#F3EFE6] z-10" />
    </div>
  );
}

export default function Process() {
  return (
    <section id="process" className="relative py-24 lg:py-32 bg-[#F3EFE6] border-y border-stone-200 overflow-hidden">
      <div className="pointer-events-none absolute top-0 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-amber-400/15 blur-[120px]" />
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Our Manufacturing Process"
          title={<>From drawing to dispatch — under one roof</>}
          align="center"
        />

        <div className="relative mt-16 lg:mt-20">
          {/* rail */}
          <span className="absolute left-[9px] lg:left-1/2 lg:-translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-amber-500/70 via-stone-300 to-transparent" />
          <div className="space-y-2">
            {PROCESS_STEPS.map((step, i) => (
              <StepCard key={step.title} step={step} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
